import * as React from 'react'
import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'
import { Props } from './type'
export const MicIcon = (props: Props) => (
  <Svg viewBox='0 0 20 20' fill='none' {...props}>
    <G clipPath='url(#clip0_4592_4956)'>
      <Path
        d='M15.8334 8.33325V9.99992C15.8334 11.547 15.2188 13.0307 14.1249 14.1247C13.0309 15.2187 11.5472 15.8333 10.0001 15.8333M10.0001 15.8333C8.45298 15.8333 6.96925 15.2187 5.87529 14.1247C4.78133 13.0307 4.16675 11.547 4.16675 9.99992V8.33325M10.0001 15.8333V19.1666M6.66675 19.1666H13.3334M10.0001 0.833252C9.33704 0.833252 8.70115 1.09664 8.23231 1.56548C7.76347 2.03433 7.50008 2.67021 7.50008 3.33325V9.99992C7.50008 10.663 7.76347 11.2988 8.23231 11.7677C8.70115 12.2365 9.33704 12.4999 10.0001 12.4999C10.6631 12.4999 11.299 12.2365 11.7678 11.7677C12.2367 11.2988 12.5001 10.663 12.5001 9.99992V3.33325C12.5001 2.67021 12.2367 2.03433 11.7678 1.56548C11.299 1.09664 10.6631 0.833252 10.0001 0.833252Z'
        stroke='#FE5000'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </G>
    <Defs>
      <ClipPath id='clip0_4592_4956'>
        <Rect width={20} height={20} fill='white' />
      </ClipPath>
    </Defs>
  </Svg>
)
